import React, { useEffect, useState } from 'react';
import { ZahtjeviTable } from './ZahtjeviTable';
import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { Tab } from '../buttons/Tab';
import { useLocation } from 'react-router-dom';
import { setReachedDocumentsFilter } from '../../store/slice/DocumentsFilterSlice';
import { DocumentsFilter } from '../../common/types/types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UploadPDF } from '../dashboard/UploadPDF';

import { toggleUpdateDocumentsTable } from '../../store/slice/ZahtjeviSlice';

export const ZahtjeviComponent = () => {
  const documentsFilter = useAppSelector((state) => state.documentsFiler.reachedDocumentsFilter);
  const dohvaceniZahtjevi = useAppSelector((state) => state.zahtjevi.dohvaceniZahtjevi);

  const [tab, setTab] = React.useState<string>(documentsFilter.tabText);
  const [status, setStatus] = React.useState<number>(documentsFilter.tabStatus);
  const [showUpload, setShowUpload] = React.useState<boolean>(false);

  const dispatch = useAppDispatch();
  const location = useLocation();

  let wasDocumentDelted: boolean = location.state?.delete;

  const setShowUploadFalse = (isUploaded: boolean) => {
    setShowUpload(false);
    if (isUploaded) {
      toastMessage('Files succesfully uplaoded');
      dispatch(toggleUpdateDocumentsTable());
    }
  };

  const toastMessage = (message: string) => {
    toast.success(message, {
      theme: 'colored',
      autoClose: 5000,
    });
  };

  useEffect(() => {
    if (wasDocumentDelted) {
      toastMessage('Document deleted');
    }
  }, [wasDocumentDelted]);

  const tabChange = (status: number) => {
    let statusText = 'All';
    if (status === 0) statusText = 'All';
    if (status === 1) statusText = 'Processing';
    if (status === 2) statusText = 'Ready';
    if (status === 3) statusText = 'Confirmed';
    if (status === 4) statusText = 'Problem';
    if (status === 5) statusText = 'Archived';

    if (status === 7) statusText = 'Confirmed';
    setTab(statusText);
    setStatus(status);
    dispatch(
      setReachedDocumentsFilter({
        tabStatus: status,
        tabText: statusText,
        date: documentsFilter.date,
        search: documentsFilter.search,
      } as DocumentsFilter)
    );
  };

  let processingCount = 0;
  let readyCount = 0;
  let confitmedCount = 0;
  let problemCount = 0;

  dohvaceniZahtjevi.forEach((zahtjev) => {
    if (zahtjev.Status === 1) processingCount++;
    if (zahtjev.Status === 2) readyCount++;
    if (zahtjev.Status === 3) confitmedCount++;
    if (zahtjev.Status === 4) problemCount++;
    if (zahtjev.Status === 7) confitmedCount++;
  });
  return (
    <div>
      <div className='dashboard-header margin-left-2 margin-bottom-1 margin-top-3'>
        <button onClick={() => setShowUpload(true)} className='button-primary font-h5-medium margin-right-1'>
          Upload PDF-s
        </button>
        <Tab onClick={tabChange} status={0} text={'All'} number={0} color={''} selected={tab}></Tab>
        <Tab onClick={tabChange} status={1} text={'Processing'} number={processingCount} color={'dark'} selected={tab}></Tab>
        <Tab onClick={tabChange} status={2} text={'Ready'} number={readyCount} color={'blue'} selected={tab}></Tab>
        <Tab onClick={tabChange} status={3} text={'Confirmed'} number={confitmedCount} color={'green'} selected={tab}></Tab>
        <Tab onClick={tabChange} status={4} text={'Problem'} number={problemCount} color={'red'} selected={tab}></Tab>
        <Tab onClick={tabChange} status={5} text={'Archived'} number={0} color={''} selected={tab}></Tab>
      </div>
      {showUpload && <UploadPDF setModalOn={setShowUpload} setShowUploadFalse={setShowUploadFalse} />}

      <ZahtjeviTable toastMessage={toastMessage} status={status} />

      <ToastContainer
        position='bottom-center'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
